import {useMutation} from '@apollo/react-hooks';

import type {
    UndeleteEmailSequenceTemplate as UndeleteEmailSequenceTemplateMutation,
    UndeleteEmailSequenceTemplateVariables as UndeleteEmailSequenceTemplateMutationVariables,
} from 'nutshell-graphql-types';

import UNDELETE_EMAIL_SEQUENCE from '../mutations/undelete-email-sequence-template.graphql';

export function useUndeleteEmailSequenceTemplate(): {
    undeleteEmailSequenceTemplate: (id: string) => Promise<any>;
} {
    const [undeleteEmailSequenceTemplate] = useMutation<
        UndeleteEmailSequenceTemplateMutation,
        UndeleteEmailSequenceTemplateMutationVariables
    >(UNDELETE_EMAIL_SEQUENCE);

    return {
        undeleteEmailSequenceTemplate: (id: string) =>
            undeleteEmailSequenceTemplate({
                variables: {
                    sequenceTemplate: {id},
                },
            }),
    };
}
